import { Link } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import HireTalent from '../app/HireTalent';
import Tips from '../JobHome/Tips';
import Blogs from '../app/Blogs';
import Categories from '../app/Categories';
import Footer from '../../components/app/Footer';
import JobDesc from '../DailyJobs/JobDesc';
import { Typography } from '@mui/material';
import toList from '../utils/ComponentUtil';
import { useEffect, useState } from 'react';
import TalentsAPI from '../Apis/TalentsAPI';
import JobsAPI from '../Apis/JobsAPI';
import PostJobTemplate from './PostJobTemplate';
import JobCard from './JobCard';


function PostJobPage() {
    const [jobs, setTalents] = useState(JobsAPI.getJobs());


    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography className="job-page-name">Post A Job</Typography>]

    return (
        <>
        <Navbar selected='For Companies'/>
        <JobDesc talents={jobs} talentsTitle={' Jobs'} breadcrumbs={breadcrumbs} 
        template={JobCard}
        startPosting={false} render={() => {
            return <PostJobTemplate/>
        }}></JobDesc>
        <HireTalent/>
        <Tips/>
        <Blogs></Blogs>
        <Categories></Categories>
        <Footer></Footer>
        </>
    );
}

export default PostJobPage;